// tslint:disable:no-bitwise
export enum RoleTypes {
    None = 0,
    User = 1,
    AdministratorRestrict = 2,
    AdministratorMaster = 4,
    PartnerRestrict = 8,
    PartnerMaster = 16,

    All = User | AdministratorRestrict | AdministratorMaster | PartnerRestrict | PartnerMaster,

    InternalAdministrators = AdministratorRestrict | AdministratorMaster,
    InternalUsers = User | InternalAdministrators,
    Administrators = InternalAdministrators | PartnerMaster,
    Partners = PartnerRestrict | PartnerMaster,
}
